<head>
<link [attr.data-nonce]="nonce"  href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600" rel="stylesheet" />
  <link [attr.data-nonce]="nonce"  href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined" rel="stylesheet" />
  <link [attr.data-nonce]="nonce"  href="https://ok1static.oktacdn.com/assets/js/sdk/okta-signin-widget/2.9.0/css/okta-sign-in.min.css"
    type="text/css" rel="stylesheet" />
  <link [attr.data-nonce]="nonce"  rel="preconnect" href="https://maps.googleapis.com" crossorigin>
  <link [attr.data-nonce]="nonce"  rel="icon" type="image/x-icon" href="favicon.ico" />
  <link [attr.data-nonce]="nonce"  href="https://cdn.materialdesignicons.com/2.1.19/css/materialdesignicons.min.css" rel="stylesheet" />
 <style [attr.data-nonce]="nonce">
    .assurant-loader-wraper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      z-index: 11111111111111111;
    }

    .assurant-loader-wraper .assurant-loader {
      position: relative;
      left: 50%;
      top: 50%;
      height: 10vw;
      width: 10vw;
      margin: -7vw 0 0 -5vw;
      border: 3px solid transparent;
      border-top-color: #06c;
      border-bottom-color: #06c;
      border-radius: 50%;
      z-index: 2;
      -webkit-animation: spin 2s linear infinite;
      -moz-animation: spin 2s linear infinite;
      -o-animation: spin 2s linear infinite;
      animation: spin 2s linear infinite;
    }

    .assurant-loader-wraper .assurant-loader::after {
      content: "";
      position: absolute;
      top: 5%;
      bottom: 5%;
      left: 5%;
      right: 5%;
      border: 3px solid transparent;
      border-top-color: #0c3;
      z-index: 2;
      border-radius: 50%;
      -webkit-animation: spin 1.5s linear infinite;
      -moz-animation: spin 1.5s linear infinite;
      -o-animation: spin 1.5s linear infinite;
      animation: spin 1.5s linear infinite;
    }

    .assurant-loader-wraper .assurant-loader::before {
      content: "";
      position: absolute;
      top: 2%;
      bottom: 2%;
      left: 2%;
      right: 2%;
      border: 3px solid transparent;
      z-index: 2;
      border-top-color: #f90;
      border-radius: 50%;
      -webkit-animation: spin 3s linear infinite;
      -moz-animation: spin 3s linear infinite;
      -o-animation: spin 3s linear infinite;
      animation: spin 3s linear infinite;
    }

    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      50% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(180deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      50% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(180deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      50% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(180deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      50% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(180deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  </style>
</head>
<assurant-loader></assurant-loader>
<loader-progress></loader-progress>

<router-outlet></router-outlet>
